import React, {useState} from 'react'
import { Link }  from 'gatsby'
import { StVideoPost } from './style.css'
import Fade from 'react-reveal/Fade'
import Content from '../Content'
import Image from '../../../components/Image'
import VideoPlayer from '../../../components/VideoPlayer'
import Share from '../../../components/Sharer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const VideoPost = ({ post, firstitem, single }) => {
  const {title, slug = '#', acf, excerpt} = post
  const creditos = acf.creditos || null
  const imagen = acf.imagen || null
  const video = acf.video || null
  const [revealed, setRevealed] = useState(false)
  const [hovered, setHovered] = useState(false)

  const imgfilename = imagen ? imagen.split('\\').pop().split('/').pop() : null

  const textextension = title.length >= 100
    ? 3
    : title.length >= 50
      ? 2
      : 1

  const largestLength = (phrase) => {
    const result = phrase.split(' ').reduce((maxLengthWord, currentWord) => {
      if(currentWord.length > maxLengthWord.length){
        return currentWord
      } else {
        return maxLengthWord
      }
    }, '')
    return result.length
  }

  const hasLargeWord = largestLength(title) >= 10 ? true : false

  return (
    <StVideoPost className={`${firstitem ? 'firstitem' : 'nextitems'} ${single ? 'single' : ''}`}>
      {
        video && single ? (
          <div className={`videoWrapper ${hovered ? 'hovered' : ''}`}>
            <div className="videoPlayerWrapper" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
              <VideoPlayer url={video} noProportions />
            </div>
            <div className="videoOverlay">
              <h2>{title}</h2>
              {
                creditos && (
                  <div className="credits" dangerouslySetInnerHTML={{ __html: creditos }}></div>
                )
              }
            </div>
          </div>
        ) : ''
      }
      <div className={`postvideo ${textextension === 3 ? 'length-large' : textextension === 2 ? 'length-medium' : 'length-small'}` }>
        <div className="postwrap">
          <div className="col col1">
          <Fade onReveal={ () => setRevealed(true)}>
            {
              revealed && (
                <>
                  <Link className="link" to={`/${slug}`} target="_blank" rel="noopener noreferrer">
                    <h2 className={`${ hasLargeWord ? 'large-word' : ''}`}>
                      {title}
                    </h2>
                    <div className="excerpt" dangerouslySetInnerHTML={{ __html: excerpt }} />
                    {
                      creditos && (
                        <div className="credits" dangerouslySetInnerHTML={{ __html: creditos }}></div>
                      )
                    }
                  </Link>
                  <Share
                    socialConfig={{
                      twitterHandle: 'latercera',
                      config: {
                        url: `https://especiales.latercera.com/palestina/${slug}/`,
                        title: `${title} - La Tercera`,
                      }
                    }}
                  />
                </>
              )
            }
          </Fade>
          </div>
          {
            imgfilename && (
              <div className="imgwrap col col2">
                <Link className="link" to={`/${slug}`} target="_blank" rel="noopener noreferrer">
                  <Image filename={imgfilename} />
                  {
                    video && (
                      <div className="playicon">
                        <FontAwesomeIcon className="" icon={['fas', 'play']} />
                      </div>
                    )
                  }
                </Link>
              </div>
            )
          }
        </div>
      </div>
      {
        single && post.content ?
        <Content raw={post.raw} />
        : ''
      }
    </StVideoPost>
  )
}

export default VideoPost